import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FalconCloseButton from 'components/common/FalconCloseButton';
import IconButton from 'components/common/IconButton';
import PropTypes from 'prop-types';
import { default as React, useEffect, useState } from 'react';
import { Button, Col, Form, ListGroup, Modal, Row, Spinner } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import 'react-loading-skeleton/dist/skeleton.css';
import useToken from '../../hooks/useToken';
import { useToast } from '../../context/providers/ToastProvider';

const SeccionUsuariosNubeAkasia = ({
    idLicencia,
    licencias,
    getInformacionDetalladaLicenciaByID,
    usuariosNube,
    setUsuariosNube
}) => {
    
    const [showModalAgregarUsuarioNube, setShowModalAgregarUsuarioNube] = useState(false);
    const [procesandoModal, setProcesandoModal] = useState(false);
    const { register, reset, handleSubmit, setValue, formState: { errors } } = useForm();
    const [cargando, setCargando] = useState(false);
    const [sucursales, setSucursales] = useState([]);   
    const { showErrorToast, showSuccessToast } = useToast();

    /**
    * AUTENTICACION
    */
    const { token, setToken } = useToken();

    /**
  * Submit de nuevo usuario nube
  * @param {any} data
  */
    const onSubmitNuevoUsuarioNube = data => {
        setProcesandoModal(true);
        registrarUsuarioNubeAkasia(JSON.stringify(data));
    };


    /**
     * FUNCIONES
     * SPRINT_18
     * Obtener Sucursales De la empresa
     * @param {any} idLicencia
     */
    const obtenerSucursalesDeEmpresa = async () => {
        
        const response = await fetch("/api/licencia/ObtenerSucursalesEmpresa?idLicencia=" + idLicencia, {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();
            console.log(data);
            if (data != null) {
                setSucursales(data);
                setCargando(false);
            }
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    /**
    * Registrar usuario nuevo en Akasia
    * @param {any} values
    */
    const registrarUsuarioNubeAkasia = async (values) => {
        setCargando(true);
        console.log(values);
        const response = await fetch("/api/usuarionubeakasia/RegistrarUsuarioNubeAkasia/?values=" + encodeURIComponent(values), {
            method: 'POST',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {

            const data = await response.json();
            console.log(data);

            showSuccessToast(data.vMessage);

            getInformacionDetalladaLicenciaByID();

        }
        else {

            showErrorToast(response.status + ' ' + response.statusText);

            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }

        }

        setShowModalAgregarUsuarioNube(false);
        setProcesandoModal(false);
        setCargando(false);
        reset();

    };

    /**
     * Obtiene cadena al azar
     * @param {any} action
     */
    const ObtenerCadenaRandom = async (action) => {
        const response = await fetch("/api/licencia/ObtenerCadenaRandom", {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'text/plain'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.text();
            console.log(data);

            if (action == 'Usuario')
                setValue("vUsuario", data);
            else if (action == 'Contrasena')
                setValue("vContrasena", data);

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };


    /**
    * Obtiene detalles
    */
    const ObtenerListaUsuariosNubeAkasia = async () => {

        const response = await fetch("/api/licencia/ObtenerListaUsuariosNubeAkasia/?idLicencia=" + idLicencia, {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {
                showErrorToast('' + error.message);
                console.log('Hubo un problema con la peticion Fetch:' + error.message);
            });

        if (response.ok) {


            //console.log(response);
            const data = await response.json();

            setUsuariosNube(data);

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
    };

    useEffect(() => {
        ObtenerListaUsuariosNubeAkasia();

    }, []);

    return (
        <>
            <Row className="align-items-center">
                <Col>
                    <h5 className="mb-0">Usuarios Nube Akasia</h5>
                </Col>
                <Col xs="auto">

                    {licencias.bIsActive &&
                        <IconButton
                            onClick={() => { setShowModalAgregarUsuarioNube(true) }}
                            iconClassName="fs--2 me-1"
                            variant="falcon-default"
                            size="sm"
                            icon="pencil-alt"
                        >
                            Nuevo Usuario Nube
                        </IconButton>
                    }
                </Col>
            </Row>
            <hr></hr>

            {
                usuariosNube.map((u, index) => {
                    return <ListGroup.Item key={index} className="border-top fs--1"  >                   
                        <Row>
                            <Col md={10}>                                
                                <img
                                    title={u.vStatus}
                                    /*onClick={setShowModalRenovarUsuarioNubeAkasia(true) }*/
                                    width={30}
                                    src={u.vStatus.includes("VC ") ? "/img/desactivada48.png" : "/img/activada48.png"}>
                                </img>
                                <FontAwesomeIcon icon="user" className="ms-2" />&nbsp;&nbsp;{u.vNombre}
                            </Col>
                            <Col md={2}>
                                <IconButton
                                    onClick={() => { window.location.href = `/servicios/usuarios-nube-akasia/editar/${u.idUsuarioNubeAkasia}` }}
                                    variant="falcon-default"
                                    size="sm"
                                    icon="pencil-alt"
                                >
                                </IconButton>
                            </Col>
                        </Row>
                    </ListGroup.Item>
                })
            }

            {showModalAgregarUsuarioNube &&
                <Modal
                    show={showModalAgregarUsuarioNube}
                    onHide={() => setShowModalAgregarUsuarioNube(false)}
                    onShow={obtenerSucursalesDeEmpresa}
                    size="md"
                    backdrop="static"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header>
                        <Modal.Title>Registrar Usuario Nube Akasia. </Modal.Title>
                        <FalconCloseButton className="btn btn-circle btn-sm transition-base p-0" onClick={() => { setShowModalAgregarUsuarioNube(false); reset() }} />
                    </Modal.Header>
                    <Modal.Body >
                        <Form noValidate onSubmit={handleSubmit(onSubmitNuevoUsuarioNube)}>
                            <Row className="g-3 mb-3">
                                {cargando ? (<h3><Spinner className="text-inline" animation="border" variant="primary" /> Cargando...</h3>)
                                    :
                                    (
                                        <>
                                            <Col lg={12}>
                                                <>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Usuario</Form.Label>
                                                        <IconButton
                                                            className="ms-2"
                                                            iconClassName="fs--2 me-1"
                                                            variant="falcon-primary"
                                                            size="sm"
                                                            icon="circle"
                                                            onClick={() => { ObtenerCadenaRandom('Usuario') }}
                                                        >
                                                            Generar
                                                        </IconButton>
                                                        <Form.Control
                                                            autoComplete="off"
                                                            type="text"
                                                            onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                                            isInvalid={!!errors.vUsuario}
                                                            {...register("vUsuario",
                                                                {
                                                                    required: 'El vUsuario es requerido',
                                                                    maxLength: 40
                                                                })
                                                            }
                                                        />
                                                        <Form.Control.Feedback type="invalid">
                                                            {errors.vUsuario && errors.vUsuario.message}
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                    <Form.Group className="mb-3">

                                                        <Form.Label>Contrase&ntilde;a</Form.Label>

                                                        <IconButton
                                                            className="ms-2"
                                                            iconClassName="fs--2 me-1"
                                                            variant="falcon-primary"
                                                            size="sm"
                                                            icon="circle"
                                                            onClick={() => { ObtenerCadenaRandom('Contrasena') }}

                                                        >
                                                            Generar
                                                        </IconButton>

                                                        <Form.Control
                                                            autoComplete="off"
                                                            type="text"
                                                            onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                                            isInvalid={!!errors.vContrasena}
                                                            {...register("vContrasena",
                                                                {
                                                                    required: 'El vContrasena es requerido',
                                                                    maxLength: 40
                                                                })
                                                            }
                                                        />

                                                        <Form.Control.Feedback type="invalid">
                                                            {errors.vContrasena && errors.vContrasena.message}
                                                        </Form.Control.Feedback>

                                                    </Form.Group>

                                                    <Form.Group className="mb-3" >
                                                        <Form.Group className="mb-3" >
                                                            <Form.Control
                                                                type="hidden"
                                                                defaultValue={licencias.idClienteAkasia}
                                                                {...register("idClienteAkasia")
                                                                }
                                                            >
                                                            </Form.Control>

                                                        </Form.Group>
                                                    </Form.Group>


                                                    <Form.Group className="mb-3" >
                                                        <Form.Control
                                                            type="hidden"
                                                            defaultValue={idLicencia}
                                                            {...register("idLicencia")
                                                            }
                                                        >
                                                        </Form.Control>
                                                    </Form.Group>


                                                    {/*SPRINT_18*/}
                                                    <Form.Group className="mb-3" >
                                                        <Form.Label>Sucursal Asignada</Form.Label>
                                                        <Form.Select
                                                            aria-label="Default select"
                                                            isInvalid={!!errors.idSucursal}
                                                            {...register("idSucursal",
                                                                {
                                                                    required: true
                                                                })
                                                            }
                                                        >
                                                            {sucursales.map((sucursal, index) => {
                                                                return (<option key={index} value={sucursal.idSucursal}>{sucursal.idSucursal} - {sucursal.vNombreSucursal}</option>)
                                                            })}
                                                        </Form.Select>
                                                        <Form.Control.Feedback type="invalid">
                                                            {errors.idSucursal && errors.idSucursal.message}
                                                        </Form.Control.Feedback>
                                                    </Form.Group>


                                                    <Form.Group className="mb-3" >
                                                        <Form.Label>Nombre y apellidos del usuario</Form.Label>
                                                        <Form.Control
                                                            autoComplete="off"
                                                            type="text"
                                                            onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                                            placeholder="Nombre y apellidos"
                                                            isInvalid={!!errors.vNombre}
                                                            {...register("vNombre",
                                                                {
                                                                    required: 'El nombre del cliente es requerido',
                                                                    maxLength: 200,
                                                                    minLength: 1
                                                                })
                                                            }
                                                        />
                                                        <Form.Control.Feedback type="invalid">
                                                            {errors.vNombre && errors.vNombre.message}
                                                        </Form.Control.Feedback>
                                                    </Form.Group>


                                                    <Row>
                                                        <Col>
                                                            &nbsp;
                                                        </Col>
                                                        <Col xs="auto">
                                                            {procesandoModal ?
                                                                <Button variant="primary" disabled>
                                                                    <Spinner
                                                                        as="span"
                                                                        animation="grow"
                                                                        size="sm"
                                                                        role="status"
                                                                        aria-hidden="true"
                                                                    />
                                                                    Procesando...
                                                                </Button>
                                                                :
                                                                <IconButton
                                                                    className="ms-2"
                                                                    iconClassName="fs--2 me-1"
                                                                    variant="falcon-default"
                                                                    size="sm"
                                                                    icon="check"
                                                                    type="submit"
                                                                >
                                                                    Guardar Cambios
                                                                </IconButton>}
                                                        </Col>
                                                    </Row>

                                                </>
                                            </Col>
                                        </>
                                    )}
                            </Row>
                        </Form>
                    </Modal.Body>
                </Modal>
            }

           
        </>
    )
}

SeccionUsuariosNubeAkasia.propTypes = {
    idLicencia: PropTypes.string,
    licencias: PropTypes.object,
    getInformacionDetalladaLicenciaByID: PropTypes.func,
    usuariosNube: PropTypes.array,
    setUsuariosNube: PropTypes.func
};

export default SeccionUsuariosNubeAkasia;